import { createContext, useContext } from 'react';

export interface SiteContextValue {
  /** Call to action: tracks `cta_click` and opens the existing SignupModal */
  openSignup: () => void;
  openLogin: () => void;
}

export const SiteContext = createContext<SiteContextValue>({
  openSignup: () => undefined,
  openLogin: () => undefined,
});

/** What a custom frontend page needs from the app (`src/sites`). */
export const useSite = (): SiteContextValue => useContext(SiteContext);
